// Zeitlimit-Check für simpleMode (Spec 2026-07-30 §4): über dem Admin-
// targetDuration → rote Warn-Pill. Nur Anzeige, blockt nichts.
export function overLimit(
  chips: { offset: number; dur: number }[],
  limitSec: number | null | undefined,
): { over: boolean; endSec: number } {
  const endSec = chips.reduce((m, c) => Math.max(m, c.offset + c.dur), 0);
  if (!limitSec || limitSec <= 0) return { over: false, endSec };
  return { over: endSec > limitSec, endSec };
}
